import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private router: Router
  ) {}

  async canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const isLoggedIn = (await this.authService.ensureLoggedIn(state.url)) ?? false;
    if (!isLoggedIn) return false;

    return this.popRedirectUrlAfterLogin() ?? true;
  }

  private popRedirectUrlAfterLogin() {
    const targetUrl = this.authService.popTargetUrlOnLogin();
    if (targetUrl === undefined) {
      return;
    }
    return this.router.parseUrl(targetUrl);
  }
}
